import React from 'react';
import { StepProps } from '../common/types';


export const OtherInfoTab: React.FC<StepProps> = ({ formik }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">
        Other Information
      </h3>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Employee Qualification
          </label>
          <input
            name='qualification'
            type="text"
            value={formik.values.qualification || ''}
            onChange={formik.handleChange}
            placeholder="Enter Qualification"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Aadhar Number
          </label>
          <input
            name='adhar_no'
            type="text"
            value={formik.values.adhar_no || ''}
            onChange={formik.handleChange}
            placeholder="Enter Aadhar Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            PAN Number
          </label>
          <input
            name='pan_no'
            type="text"
            value={formik.values.pan_no || ''}
            onChange={formik.handleChange}
            placeholder="Enter PAN Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            PF Number
          </label>
          <input
            type="text"
            value={formik.values.pf || ''}
            onChange={(e) => onInputChange('pf_number', e.target.value)}
            placeholder="Enter PF Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div> */}
      </div>
      <div className="grid grid-cols-2 gap-6">
        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            ESC Number
          </label>
          <input
            type="text"
            value={formik.values. || ''}
            onChange={(e) => onInputChange('esc_number', e.target.value)}
            placeholder="Enter ESC Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div> */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            PF UAN Number
          </label>
          <input
            name='uan'
            type="text"
            value={formik.values.uan || ''}
            onChange={formik.handleChange}
            placeholder="Enter PF UAN Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Driver's License Number
          </label>
          <input
            name='dl_no'
            type="text"
            value={formik.values.dl_no || ''}
            onChange={formik.handleChange}
            placeholder="Enter License Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            License Expiry Date
          </label>
          <input
            name='dl_expiry_date'
            type="date"
            value={formik.values.dl_expiry_date || ''}
            onChange={formik.handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Blood Group
        </label>
        <select
          name='blood_group'
          value={formik.values.blood_group || ''}
          onChange={formik.handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select Blood Group</option>
          <option value="A+">A+</option>
          <option value="A-">A-</option>
          <option value="B+">B+</option>
          <option value="B-">B-</option>
          <option value="AB+">AB+</option>
          <option value="AB-">AB-</option>
          <option value="O+">O+</option>
          <option value="O-">O-</option>
        </select>
      </div>
    </div>
  );
};
